import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {CurrencyService} from 'app/blocks/service/api/currency.service';
import {Resource} from 'app/constants/resource';

import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {ICurrency} from 'app/blocks/model/currency.model';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {Currency} from 'app/blocks/model/currency.model';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';

@Injectable({
    providedIn: 'root'
})
export class CurrencyResource extends AbstractEntityResource<ICurrency> {
    constructor(currencyService: CurrencyService, router: Router) {
        super(
            Resource.CURRENCIES,
            currencyService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.CURRENCIES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.CURRENCIES),
            (entity?) => new Currency(entity),
            (entity) => entity.code
        );
    }
}
